<div class="object-view-field-values {{stylingClass}}">
  @if (fieldValues.title_values) {
    <span class="object-view-field-values__title-values">
      @for (titleValue of fieldValues.title_values; track $index) {
        <app-object-view-field-value
          [edit]="edit"
          [fieldValue]="titleValue"
        ></app-object-view-field-value>
      }
    </span>
  }

  <p
    class="object-view-field-values__content-values"
    [ngClass]="{'content-has-title': fieldValues.title_values,
                'content-has-icon': fieldValues.field_icon}"
  >
    @if (fieldValues.field_icon) {
      <i
        class="object-view-field-values__icon {{fieldValues.field_icon.icon}}"
      >
        {{fieldValues.field_icon.icon_frame}}
      </i>
    }

    @for (fieldValue of fieldValuesValues; track $index) {
      <app-object-view-field-value
        class="object-view-field-values__field-value"
        [edit]="edit"
        [fieldValue]="fieldValue"
        [fieldValueClass]="fieldValueClass"
        [sectionsContainer]="sectionsContainer"
      ></app-object-view-field-value>
    }
  </p>
</div>

